import React from 'react';

import { type CellContext } from '@tanstack/react-table';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { cn } from 'src/utils';

interface CellIndexProps<TData, TValue> extends CellContext<TData, TValue> {
    className?: string;
}

export function CellLongText<TData, TValue>({ getValue, className }: CellIndexProps<TData, TValue>) {
    const value: string = getValue();

    return (
        <Tooltip>
            <TooltipProvider>
                <TooltipTrigger className={cn('truncate', className)}>{value ?? '-'}</TooltipTrigger>
                {value && <TooltipContent className="max-w-xs text-wrap">{value}</TooltipContent>}
            </TooltipProvider>
        </Tooltip>
    );
}
